export default __webpack_public_path__ + "img/93d42996bf6d0d2703e4dd1981138800.png";